<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">武侠管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>结算管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getRecordList"></create>
        <create-reward @refresh="getRecordList"></create-reward>
        <create-reward-addition @refresh="getRecordList"></create-reward-addition>
      </div>
      <el-table :data="list">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="leagueId" label="门派ID">
          <template slot-scope="scope">
            {{
            scope.row.leagueId === -1 ? '所有' : scope.row.leagueId
            }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="结算开始时间">
          <template slot-scope="scope">
            {{
            scope.row.startTime | moment
            }}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="结算结束时间">
          <template slot-scope="scope">
            {{
            scope.row.endTime | moment
            }}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="创建时间">
          <template slot-scope="scope">
            {{
            scope.row.createTime | moment
            }}
          </template>
        </el-table-column>
        <el-table-column prop="annualizedRate" label="月化率">
          <template slot-scope="scope">{{ math.multiply(scope.row.annualizedRate, 100) }} %</template>
        </el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 2">奖励补发</el-tag>
            <el-tag v-if="scope.row.type === 1">奖励结算</el-tag>
            <el-tag type="warning" v-if="scope.row.type === 0">利息结算</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="info">未结算</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success">已结算</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="danger">失败</el-tag>
            <el-tag v-else-if="scope.row.status === 3" type="default">已转账</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.status !== 0"
              :to="{
                path: '/home/league/settle/records',
                query: { settleId: scope.row.id }
              }"
            >
              <el-button size="small">查看列表</el-button>
            </router-link>
            <el-button
              v-if="scope.row.status !== 0"
              @click="seeTotal(scope.row.id)"
              size="small"
            >查看总量</el-button>
            <el-button
              type="danger"
              v-if="scope.row.status === 1"
              @click="revert(scope.row.id)"
              size="small"
            >撤回</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
import Create from "./components/Create";
import CreateReward from "./components/CreateReward";
import CreateRewardAddition from "./components/CreateRewardAddition";
import math from "common/math";
export default {
  name: "leagueMain",
  data() {
    return {
      filter: {},
      math
    };
  },
  components: {
    Create,
    Pagination,
    CreateReward,
    CreateRewardAddition
  },
  computed: {
    ...mapState("leagueSettle", ["list", "pagination", "totalCount"])
  },
  methods: {
    ...mapActions("leagueSettle", [
      "getList",
      "getSettleTotal",
      "revertSettle"
    ]),
    getRecordList(data = {}) {
      this.getList({ ...this.pagination, ...this.filter, ...data });
    },
    handleCurrentChange(pagination) {
      this.getRecordList(pagination);
    },
    revert(id) {
      this.$confirm("确认要进行此操作吗？", "提示", { type: "warning" }).then(
        () => {
          this.revertSettle(id).then(() => {
            this.$message.success("操作成功！");
            this.getRecordList();
          });
        }
      );
    },
    seeTotal(id) {
      this.getSettleTotal(id).then(res => {
        this.$alert(res.data, "总量");
      });
    }
  },
  created() {
    this.getRecordList();
  }
};
</script>
<style lang="less" scoped>
::v-deep .el-button,
a {
  margin-left: 10px;
}
</style>
